<div mdbModal #verErrores="mdb-modal" class="modal fade" style="overflow-y: auto;" id="basicExample" tabindex="-1"
    role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
    [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title w-100 text-left" id="myModalLabel">
                    Errores
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="verErrores.hide()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <h5>Ocurrieron los siguientes errores:</h5>
                <div class="table-responsive">
                    <table class="table table-striped table-hover table-sm align-middle">
                        <thead class="grey lighten-2">
                            <tr>
                                <th scope="col" class="text-center">Tipo</th>
                                <th scope="col" class="text-center">Descripción</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="listaErroresAll?.length === 0">
                                <td colspan="100%" style="text-align: center">
                                    Sin errores
                                </td>
                            </tr>
                                <tr *ngFor="let detalle of listaErrores">
                                    <td>{{detalle.tipo}}</td>
                                    <td>{{detalle.texto}}</td>
                                </tr>
                        </tbody>
                        <app-pagination [context]="paginationContext"
                            (onPageChange)="onPageChange($event)" *ngIf="listaErroresAll?.length > 0">
                        </app-pagination>
                    </table>
                </div>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="closeModal()"
                    mdbWavesEffect>
                    Cerrar
                </button>
            </div>
        </div>
    </div>
</div>
